import { render, staticRenderFns } from "./DataInfoTable.vue?vue&type=template&id=8bbe0058&"
import script from "./DataInfoTable.vue?vue&type=script&lang=js&"
export * from "./DataInfoTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports